module.exports = __webpack_public_path__ + "static/manish-jain-639dab9341aacc0b638d39e13812a218.jpeg";